import { render, staticRenderFns } from "./flats-crm-viewed-flats.vue?vue&type=template&id=71b4ca10"
import script from "./flats-crm-viewed-flats.vue?vue&type=script&lang=js"
export * from "./flats-crm-viewed-flats.vue?vue&type=script&lang=js"
import style0 from "./flats-crm-viewed-flats.vue?vue&type=style&index=0&id=71b4ca10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports